import Update from "../../table/Update";
import { useState,useEffect } from "react";
import ApiService from "../../../services/apiService";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateChackValve,chackValveDetailTitle } from "../../../constants";


const UpdateChackValveDetail = () =>{
    const {Id} = useParams();
    const [data,setData] = useState<any>(null);
    const[valvedata,setValvedata] = useState<any>(null);
    const [chackData, setChackData] = useState<any>([]);

    const initialData = {
        ValveNumber:valvedata?.valveNumber,
        Area: valvedata?.area,
        Line:valvedata?.line,
        ChackName:valvedata?.chakName,
        ChakId:valvedata?.chakId
        
    }

    useEffect(()=>{
        const fetchChackValveDetail = async ()=>{
            try{
                const response = await ApiService.axiosApi(`/chackvalvedetail/${Id}`,{
                    method : "GET"
                    
                })

                if(response.success){
                   
                    setValvedata(response.data);
                }else{
                    toast.error(response.message || "Unable to fetch Chack Valve Detail");
                }
            }catch(error:any){
                toast.error(error.message || "Unable to fetch Chack Valve Detail");
            }
        }
        fetchChackValveDetail();
    },[])

    const updateChackValveDetail = async (data:any)=>{
        try{
            const response = await ApiService.axiosApi(`/chackvlavedetai/${Id}`,{
                method : "PUT",
                data : data
            })
            if(response.success){
                toast.success(response.message || "Chack Valve Detail Updated Successfully");
            }else{
                toast.error(response.message || "Unable to update Chack Valve Detail");
            }   
        }catch(error:any){
            toast.error(error.message || "Unable to update Chack Valve Detail");
        }
    }
    useEffect(()=>{
        const fetchChackData = async ()=>{              
            try{
                const response = await ApiService.axiosApi(`/chack`,{
                    method: 'GET',
                    params:{
                        pageNumber:0,
                        pageSize:0
                    }
                });
                if(response.success){
                    setChackData(response.data.data);
                }
            }catch(error:any){
            toast.error(error.message || "Failed to fetch Chack Data");
        }   }
        fetchChackData();
    },[]);  

    return(
        <Update
            title={updateChackValve}
            parentTitle={chackValveDetailTitle}
            fields={[
                {
                    name : "ValveNumber",
                    label : "Valve Number",
                    type : "text",
                    validation : {required : "Valve Number is required"}
                },
                {
                    name : "Area",  
                    label : "Area",
                    type : "text",
                    validation : {required : "Area is required"}
                },
                {
                    name: "Line",
                    label: "Line",
                    type :"text",
                    validation : {required : "Line is required"},
                    Placeholder:"1 Or 2"
                },
                {
                    name:"ChackName",
                    label:"Chak",
                    isDropdown:true,
                    dropdownData:chackData,
                    dropdownLabel:"chackName",
                    idFieldName:"ChakName"
    
                }
            ]}
            onSubmit={updateChackValveDetail}
            initialData={initialData}
        />
    )
}

export default UpdateChackValveDetail;